module.exports = __webpack_public_path__ + "img/jpg.e0cb4c0f.png";